import { useDisclosure } from '@mantine/hooks';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@feathr/components';
import { getIconForAction } from '@feathr/hooks';

import ExportDonationsModal from '../ExportDonationsModal';

function ExportDonationsButton(): JSX.Element {
  const { t } = useTranslation();
  const [isModalOpen, { open: openModal, close: closeModal }] = useDisclosure(false);

  return (
    <>
      <Button
        aria-label={t('Export donation activity')}
        onClick={openModal}
        prefix={getIconForAction('export')}
        type={'secondary'}
      >
        {t('Export as CSV')}
      </Button>
      {isModalOpen && <ExportDonationsModal onClose={closeModal} opened={isModalOpen} />}
    </>
  );
}

export default ExportDonationsButton;
